import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, Search, Check } from "lucide-react";

/** Dropdown of fixed options with a search box INSIDE the open list. Value always comes from `options`. */
const SearchableSelect = ({ value, onChange, options, placeholder = "ابحث...", testid = "searchable-select", className = "" }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const wrapRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => { if (!wrapRef.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    setTimeout(() => inputRef.current?.focus(), 0);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  const q = query.trim();
  const filtered = q ? options.filter((o) => o.includes(q)) : options;

  const pick = (o) => { onChange(o); setOpen(false); setQuery(""); };

  return (
    <div ref={wrapRef} className="relative" dir="rtl">
      <button type="button" onClick={() => setOpen((v) => !v)} data-testid={`${testid}-toggle`}
        className={`${className} flex items-center justify-between text-right`}>
        <span className="truncate">{value}</span>
        <ChevronDown size={16} className={`text-[#09637E] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute z-30 mt-1 w-full bg-white border border-[#7AB2B2] rounded-lg shadow-xl overflow-hidden" data-testid={`${testid}-menu`}>
          <div className="p-2 border-b border-[#EBF4F6] flex items-center gap-2">
            <Search size={14} className="text-[#7AB2B2] shrink-0" />
            <input ref={inputRef} value={query} onChange={(e) => setQuery(e.target.value)} placeholder={placeholder}
              data-testid={`${testid}-search`}
              className="h-9 w-full text-sm bg-transparent focus:outline-none" />
          </div>
          <ul className="max-h-56 overflow-y-auto" role="listbox" data-testid={`${testid}-list`}>
            {filtered.length === 0 ? (
              <li className="p-3 text-sm text-[#666666] text-center" data-testid={`${testid}-empty`}>لا توجد نتائج مطابقة</li>
            ) : filtered.map((o) => (
              <li key={o}>
                <button type="button" onClick={() => pick(o)} data-testid={`${testid}-option-${o}`}
                  className={`w-full text-right px-3 py-2 text-sm flex items-center justify-between hover:bg-[#EBF4F6] ${o === value ? "bg-[#EBF4F6] font-bold text-[#09637E]" : "text-[#333333]"}`}>
                  <span>{o}</span>
                  {o === value && <Check size={14} />}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
